import MuiDialog from "@mui/material/Dialog";
import DialogTitle from "./components/DialogTitle";
import DialogContent from "./components/DialogContent";
import DialogActions from "./components/DialogActions";
import DialogContentText from "./components/DialogContentText";
import type { DialogProps as MuiDialogProps } from "@mui/material/Dialog";

interface DialogProps {
  id: string;
  /**
   * set the maximum width of the dialog
   * @default 300px
   */
  minWidth?: number;
  maxWidth?: number;
  open: boolean;
  /**
   * To disable close on outside click don't pass this prop
   */
  onClose?(event: React.MouseEvent): void;
  title?: React.ReactNode;
  subTitle?: string;
  text?: React.ReactNode;
  /**
   * Alternative to setting `subTitle`, and `text`.
   * If more customization is needed, use this prop instead. */
  content?: React.ReactNode;
  /**
   * Slot for passing action buttons to the dialog. */
  confirmButton?: React.ReactNode;
  cancelButton?: React.ReactNode;
  slotProps?: MuiDialogProps["slotProps"];
  severity?: "error" | "warning" | "info" | "success";
  /** @default true */
  closeAfterTransition?: boolean;
}

/** @deprecated Use DialogV2 instead */
function Dialog(props: DialogProps) {
  const {
    id,
    maxWidth = 300,
    minWidth = undefined,
    title,
    subTitle,
    text,
    content,
    confirmButton,
    cancelButton,
    slotProps,
    severity = "info",
    ...rest
  } = props;

  return (
    <MuiDialog
      aria-describedby={id}
      slotProps={{
        ...slotProps,
        paper: (ownerState) => {
          const baseProps =
            typeof slotProps?.paper === "function" ? slotProps.paper(ownerState) : (slotProps?.paper ?? {});
          return {
            ...baseProps,
            sx: { borderRadius: "20px", ...baseProps?.sx },
          };
        },
      }}
      sx={{ "& .MuiDialogContent-root": { maxWidth, minWidth } }}
      {...rest}
    >
      {props.title && (
        <DialogTitle
          title={props.title}
          onClose={rest.onClose}
          sx={severity === "error" ? { bgcolor: "error.main" } : undefined}
        />
      )}
      <DialogContent>
        {Boolean(subTitle || text) && <DialogContentText id={id} subTitle={subTitle} text={text} />}
        {content}
      </DialogContent>
      {Boolean(confirmButton || cancelButton) && (
        <DialogActions>
          {confirmButton}
          {cancelButton}
        </DialogActions>
      )}
    </MuiDialog>
  );
}
export default Dialog;
